import axios from "axios";
import moment from 'moment';

class Logs {
    getList(filter = {}) {
        return axios.get('/api/v1/action-logs', {
            params: {
                user_id: filter.user_id || null,
                date_from: filter.date_from ? moment(filter.date_from).format('YYYY-MM-DD') : null,
                date_to: filter.date_to ? moment(filter.date_to).format('YYYY-MM-DD') : null,
                action: filter.action || null
            }
        });
    }

    getDetail(id) {
        return axios.get(`/api/v1/action-logs/${id}`)
    }

    getUserLogs(userId) {
        return axios.get(`/api/users/${userId}/action-logs`)
    }
}

export default Logs